<script lang="ts" module>
  import type { CollectionLinkStoryblok } from '~/component-types-sb';
  import { page } from '$app/state';

  export interface FooterCollectionLinkProps {
    blok: CollectionLinkStoryblok;
  }
</script>

<script lang="ts">
  import { FooterLink } from '@agapi/ui/footer';
  import { storyblokEditable } from '@storyblok/svelte';
  import { storyLinkToLink } from '../../../../utils/transformer.client';
  import { rewriteUrl } from '../../../../utils';

  const { blok }: FooterCollectionLinkProps = $props();
</script>

<FooterLink
  href={rewriteUrl(page, storyLinkToLink(blok.collection?.path ?? ''))}
  use={[[storyblokEditable, blok]]}
>
  {blok.label || blok.collection?.name || ''}
</FooterLink>
